import styled from "styled-components";

import { ProfileQuestionsStyledProps as Props } from "./ProfileQuestions.types";
import CONSTANTS from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

const ProfileQuestionsStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: var(--sizes-navbar-height);
  background-color: var(--palette-gray-s0-l98);
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-areas:
    ".      header ."
    ".      main   ."
    "footer footer footer";

  @media (max-width: ${tablet}px) {
    padding-top: 0;
    grid-template-areas:
      "header header header"
      "main   main   main"
      "footer footer footer";
    background-color: var(--palette-lightgrey-s5-l90);
  }

  .ProfileQuestions {
    &__header {
      grid-area: header;

      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__main {
      grid-area: main;
      display: grid;
      grid-template-columns: minmax(26rem, 30.4rem) 1fr;
      column-gap: 2.4rem;

      @media (max-width: ${tablet}px) {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }

    &__profile-navigation {
      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__link {
      text-decoration: none;
      padding: 1.6rem 0;
      color: var(--palette-black-s0-l20);
      font-weight: 600;
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      font-size: 1.6rem;
      font-family: inherit;

      svg {
        path {
          fill: var(--palette-black-s0-l20);
        }
      }
    }

    &__content {
      max-width: 60rem;
      padding: 2rem 2.4rem;
      border-radius: 1rem;
      background-color: var(--palette-white);

      @media (max-width: ${tablet}px) {
        max-width: initial;
        min-height: 100%;
        border-radius: 0;
      }

      &__header {
        padding-bottom: 1.2rem;
        margin-bottom: 2rem;
        border-bottom: 0.1rem solid var(--palette-gray-s0-l95);
      }

      &__body {
        flex-direction: column;
        display: flex;
        font-size: 1.6rem;
      }

      &__go-back {
        width: min-content;
        margin-bottom: 4rem;

        .GoBack {
          &__icon {
            padding: 0.4rem;

            svg {
              width: 1.6rem;
              height: 1.6rem;
            }
          }
        }
      }

      &__title {
        margin-bottom: 0.4rem;
        font-size: 3.6rem;
        font-weight: 500;
        color: var(--palette-black-s0-l20);
      }
    }

    &__footer {
      grid-area: footer;
      padding-top: 3.2rem;

      @media (max-width: ${tablet}px) {
        display: none;
      }
    }
  }
`;

export default ProfileQuestionsStyled;
